<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <default-chart
            :options="settings"
            :labels="labels"
            :items="items"
            :showLegend="showLegend"
            :showGrid="showGrid"
            :dashedLines="dashedLines"
            :zoom="false"
            :height="120"
            :selected="toggle">
        </default-chart>

        <div class="chart-options">
            <label>
                <input type="checkbox" v-model="showLegend" v-on:click="toggleShowLegend"> {{ t('Show legend') }}
            </label>
            <label>
                <input type="checkbox" v-model="showGrid" v-on:click="toggleShowGrid"> {{ t('Show grid') }}
            </label>
            <label>
                <input type="checkbox" v-model="dashedLines" v-on:click="toggleDashedLines"> {{ t('Dashed lines') }}
            </label>

            <label>
                <span>{{ t('Y axis options') }}:</span>
                {{ t('Min') }}
                <input type="number" v-model="yAxisTicks.min" v-on:change="changeYAxisTicks" class="y-axis-option">
                {{ t('Max') }}
                <input type="number" v-model="yAxisTicks.max" v-on:change="changeYAxisTicks" class="y-axis-option">
                {{ t('Step') }}
                <input type="number" v-model="yAxisTicks.step" v-on:change="changeYAxisTicks" class="y-axis-option">
            </label>
        </div>
    </div>
</template>
<script>

import DefaultChart from './DefaultChart';
import ComponentTitle from "./ComponentTitle";

export default {
    components: {ComponentTitle, DefaultChart},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    showLegend: null,
                    index: null,
                    emitEvents: {},
                    visible: true,
                    showGrid: null,
                    dashedLines: null,
                }
            }
        },
        eventBus: {
            Type: Object,
        },
        routeParams: {
            Type: Object
        },
        moduleName: {
            Type: String,
            require: true,
        },
    },
    data() {
        const _this = this;
        return {
            items: [],
            labels: [],
            showLegend: false,
            showGrid: false,
            dashedLines: false,
            componentIndex: null,
            yAxisTicks: {
                min: 0,
                max: 0,
                step: 0,
            },
            settings: {
                tension: 0,
                lineJoin: 'bevel',
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        },
                        gridLines: {
                            display: false
                        },
                        afterBuildTicks: function (axis) {
                            const min = axis.chart.scales['y-axis-0'].min;
                            const max = axis.chart.scales['y-axis-0'].max;

                            _this.yAxisTicks.min = min;
                            _this.yAxisTicks.max = max;
                            _this.yAxisTicks.step = Math.ceil((max - min) / axis.chart.scales['y-axis-0'].ticks.length);
                        },
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }]
                },
                showLegend: {
                    display: false
                },
            },
            state: {},
            toggle: false,
            loadMask: '',
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.setState(this.routeParams);
        this.mountEvents();
        this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.showLegend = this.config.showLegend;
            this.showGrid = this.config.showGrid;
            this.dashedLines = this.config.dashedLines;
        },
        setState(data) {
            this.state.value = data;
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        defaultBindEvents() {
            return [{
                name: 'load',
                componentIndex: this.componentIndex,
            }];
        },
        async load(eventData, data) {
            this.addLoadMask();
            let response = await this.fetchData(data);
            this.labels = response.data.labels;
            this.items = response.data.items;
            this.removeLoadMask();
        },
        async fetchData(params) {
            this.setState(params);
            const url = this.config['loadUrl'];

            return await this.$http.get(url, {params: params});
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        setConfig(config) {
            this.dashedLines = 'dashedLines' in config ? config['dashedLines'] : false;
            this.showLegend = 'showLegend' in config ? config['showLegend'] : false;
            this.showGrid = 'showGrid' in config ? config['showGrid'] : false;
        },
        toggleShowLegend() {
            this.showLegend = !this.showLegend;
        },
        toggleShowGrid() {
            this.showGrid = !this.showGrid;
        },
        toggleDashedLines() {
            this.dashedLines = !this.dashedLines;
        },
        changeYAxisTicks() {
            this.$root.$emit('chart:changeYAxisTicks', this.yAxisTicks.min, this.yAxisTicks.max, this.yAxisTicks.step)
        },
        unmountEvents() {
            this.eventManager.unbindEvents(this.defaultBindEvents());
        }
    }
}

</script>

<style lang="scss">
.chart-options {
    padding: 20px 30px;
    text-align: center;

    .y-axis-option {
        width: 60px;
        margin-right: 10px;
    }

    label {
        margin-right: 20px;
        cursor: pointer;

        input[type="checkbox"] {
            margin-right: 5px;
        }

        span {
            padding-right: 8px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// ChartComponent.vue?76b1db1c